// Numeric positions remain for legacy links. New links also identify the
// question so a fresh quiz fetch cannot send review to a different case.
export const questionReviewPath = (examId, position, questionId, studentUserId) => {
  const prefix = studentUserId ? `/mentorships/students/${studentUserId}` : '';
  const path = `${prefix}/exam/${examId}/${position}/review`;
  return questionId ? `${path}?questionId=${encodeURIComponent(questionId)}` : path;
};

export const reviewQuestionPosition = (questions, questionId) =>
  questions.findIndex(question => question.questionId === questionId) + 1;
